import { useState, useEffect } from 'react'
import SideSheet from '../SideSheet'
import Screen1 from './Screen1'
import Screen2 from './Screen2'
import Screen3 from './Screen3'

interface PowerOfAttorneySideSheetProps {
  isOpen: boolean
  onClose: () => void
  orderId?: string
  onSignDocument: () => Promise<void>
  onDownloadDocument: () => Promise<void>
  handleGenerateDocument: () => Promise<void>
  widget?: any
  signatureStatus?: 'pending' | 'completed'
  clearWidget?: () => void
  resetSignatureStatus?: () => void
  onTrackOrder?: () => void
}

const PowerOfAttorneySideSheet = ({
  isOpen,
  onClose,
  onSignDocument,
  onDownloadDocument,
  handleGenerateDocument,
  widget,
  signatureStatus = 'pending',
  clearWidget,
  resetSignatureStatus,
  onTrackOrder
}: PowerOfAttorneySideSheetProps) => {
  const [currentScreen, setCurrentScreen] = useState(1)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (signatureStatus === 'completed' && currentScreen === 2) {
      setCurrentScreen(3)
    }
  }, [signatureStatus, currentScreen])

  const handleGenerateDocumentInternal = async () => {
    try {
      setLoading(true)
      await handleGenerateDocument()
      setCurrentScreen(2)
    } catch (error) {
      console.error('Erro ao gerar documento:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleSignDocument = async () => {
    try {
      setLoading(true)
      setLoading(false)
    } catch (error) {
      console.error('Erro ao assinar documento:', error)
      setLoading(false)
    }
  }

  const handleDownloadDocument = async () => {
    try {
      setLoading(true)
      await onDownloadDocument()
      onClose()
      setCurrentScreen(1)
      if (resetSignatureStatus) {
        resetSignatureStatus()
      }
    } catch (error) {
      console.error('Erro ao baixar documento:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    if (clearWidget) {
      clearWidget()
    }
    onClose()
    setCurrentScreen(1)
  }

  const renderScreen = () => {
    switch (currentScreen) {
      case 1:
        return <Screen1 onGenerateDocument={handleGenerateDocumentInternal} loading={loading} onClose={onClose} />
      case 2:
        return (
          <Screen2 
            onSignDocument={handleSignDocument} 
            loading={loading} 
            onClose={onClose}
            widget={widget}
            signatureStatus={signatureStatus}
          />
        )
      case 3:
        return <Screen3 onTrackOrder={onTrackOrder || (() => {})} loading={loading} onClose={onClose} />
      default:
        return null
    }
  }

  return (
    <SideSheet isOpen={isOpen} onClose={handleClose} width="450px">
      {renderScreen()}
    </SideSheet>
  )
}

export default PowerOfAttorneySideSheet
